import { Repository } from '../repository';
import { type Mitigation } from './entity';

export class Mitigations extends Repository<Mitigation> {
    private readonly prefix = 'CM';

    getByLabel(label: string): Mitigation | undefined {
        return this.items.find((mitigation) => mitigation.label === label);
    }

    getNextLabel(): string {
        const customItems = this.items.filter(
            (mitigation) => mitigation.isCustom,
        );
        const lastCustomItem = customItems[customItems.length - 1];
        if (!lastCustomItem) {
            return `${this.prefix}00001`;
        }
        const nr = parseInt(lastCustomItem.label.slice(this.prefix.length));
        const newNr = nr + 1;
        return `${this.prefix}${newNr.toString().padStart(5, '0')}`;
    }
}
